import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';

function Chapter6() {
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__title">Ruggedized Servers to the Rescue</p>
        <p className="chapter__paragraph">
          The solution was Lenovo’s{' '}
          <a
            href="https://www.lenovo.com/us/en/p/servers-storage/servers/edge/thinkedge-se450/len21te0002"
            target="_blank"
            rel="sponsored"
            style={{ color: '#7A126B', textDecoration: 'none', fontWeight: 500 }}
          >
            ThinkEdge SE450,
          </a>{' '}
          an AI-optimized edge server with a rugged design capable of withstanding extreme
          conditions while running quietly, allowing it to live comfortably in the new remote
          workspace. Lenovo worked with Island Conservation to tailor the server to its needs,
          adding additional graphics cards to increase the AI processing capability per node.
        </p>
      </section>
      <PullQuote
        quote={
          '“We took the supercomputer capability they had in Santiago and brought that into a form factor that is much smaller,” says Ferland.'
        }
      />
      <section className="chapter">
        <p className="chapter__paragraph">
          The ThinkEdge SE450 eliminated the need for on-site technicians. Unlike a data center,
          which needs staff on-site, the ThinkEdge server could be monitored and serviced remotely
          by Lenovo team members. It proved to be the perfect solution.
        </p>
        <p className="chapter__paragraph">
          Lenovo’s ThinkEdge SE450 Edge Server allows conservationists to process 4.8 images per
          second. That’s more than 400,000 photos per day. Then, only the most relevant images are
          sent via the satellite internet connection to the mainland for further analysis. Thanks to
          the Lenovo AI server powered by 3<sup>rd</sup> Gen Intel<sup>®</sup>Xeon<sup>®</sup>
          Scalable processors, and boosted connectivity, the island’s conservation projects are
          seeing efficiencies that include a 100% jump in image-processing speed. Even in its
          initial stages, the collaboration has been a quantifiable success in the real and
          substantial benefits it has shown.
        </p>
        <p className="chapter__paragraph">
          But there is always room to improve. Currently, the AI algorithm detects only the
          differences between flora and fauna, but with time, it can be trained to detect specific
          types of invasive flora and fauna with much greater accuracy. In the future, there may be
          opportunities to connect the cameras to a 5G network, eliminating the need to manually
          gather the SD cards.
        </p>
      </section>
    </>
  );
}

export default Chapter6;
